module.exports = __webpack_public_path__ + "media/2.4e42f9c8.mp3";